<template>
  <div class="info-detail">
    <!--导航-->
    <div class="dk-nav">
      <van-nav-bar
              fixed
              title="贷款详情"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    
    <!--贷款案例列表-->
    <template v-if="detail">
    <div>
      <van-panel :title="detail.title" :desc="'日期：'+detail.created_at" style="font-size: 12px;" />
      <div class="van-cell-group van-hairline--top-bottom van-panel" style="font-size: 12px;">
        <div class="van-cell van-panel__header">
          <div class="van-cell__title">
            <span v-html="detail.body"></span>
          </div>
        </div>
        <div class="van-panel__content"></div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
export default {
    'name': 'caseDetail',
    data() {
        return {

        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            detail: state => state.info.info_detail.data
        })
    },
    methods: {
      ...mapActions(['requestInfoDetail']),
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onClickLeft() {
            this.$router.push({path: '/info/list'});
        },
        filterBy(list,value){
            return list.filter(function(lists){
                return lists.city.match(value);
            })
        }
    },
    components: {

    },
    mounted() {
      this.requestInfoDetail({"thit":this,"id":this.$route.params.id});
    }
};
</script>

<style scoped>
.home >>> .van-grid-item__icon {
  font-size: 1.3rem;
}

/*导航*/
.dk-nav {
  width: 100%;
  height: 52px;
}
.info-detail >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.info-detail >>> .van-nav-bar__text {
  color: #fff;
}
.info-detail >>> .van-nav-bar__title {
  color: #fff;
}
.info-detail >>> .van-card__thumb img {
  border-radius: 0.1rem;
}
.info-detail >>> .van-nav-bar .van-icon {
  color: #fff;
}
</style>
